import classNames from 'classnames';
import React from 'react';

import CheckmarkIcon from '@/assets/checkmark.svg?react';
import { UiTypography } from '@/components/ui/Typography';
import { webCampaign } from '@/modules/webCampaign';

import { PLANS_ACCESS, VIP_PLANS_ACCESS, PlanFeatureType } from './constant';
import { MainImageProFeatureStyles } from './ProFeatures.styles';

interface PaywallProFeaturesProps {
  features?: PlanFeatureType[];
}

export const PaywallProFeatures: React.FC<PaywallProFeaturesProps> = ({
  features = PLANS_ACCESS,
}) => {
  const isVIPFeatures = features === VIP_PLANS_ACCESS;

  return (
    <MainImageProFeatureStyles staticTheme={webCampaign.getStaticTheme()}>
      <table className="pro-features-table">
        <tr>
          <td />
          <td className="hightlighted hightlighted--first">
            <UiTypography
              className="pro-features-table-title--pro"
              transform="uppercase"
              variant="label-medium-prominent"
              color="white"
              component="span"
            >
              {isVIPFeatures ? 'VIP' : 'PRO'}
            </UiTypography>
          </td>
        </tr>

        {features.map((plan, idx) => (
          <tr key={plan.title} className="row-list">
            <td>
              <UiTypography
                variant="body-medium"
                component="span"
                align="center"
              >
                {plan.title}
              </UiTypography>
            </td>
            <td
              className={classNames('hightlighted', {
                'hightlighted--last': idx === features.length - 1,
              })}
            >
              {plan.pro && (
                <UiTypography
                  variant="title-large"
                  component="span"
                  align="center"
                  className="td-icon"
                >
                  <CheckmarkIcon />
                </UiTypography>
              )}
            </td>
          </tr>
        ))}
      </table>
    </MainImageProFeatureStyles>
  );
};
